import { DidYouKnowCard } from "../molecules/DidYouKnowCard";
import { Action, DidYouKnow } from "../type";
import { Card } from "../molecules/Card";

interface CardSelectorProps {
  card: Action | DidYouKnow;
  onCardFinished: () => void;
  handleTakeAction: () => void;
  handleDontTakeAction: () => void;
}

export const CardSelector = (props: CardSelectorProps) => {
  return props.card.type === "didYouKnow" ? (
    <DidYouKnowCard
      content={props.card as DidYouKnow}
      onClose={props.onCardFinished}
    />
  ) : (
    <Card
      content={props.card as Action}
      onButtonTakeClick={props.handleTakeAction}
      onButtonDontTakeClick={props.handleDontTakeAction}
      onClosePopupClick={props.onCardFinished}
    />
  );
};
